module.exports = __webpack_public_path__ + "static/media/vf-button-women-bag.dc260cdf.svg";